import * as React from 'react';
import { IAdFoxBannerContext } from '@cian/adfox/build/react';

import { TgbExtended } from '../TgbExtended';
import { HTML5Banner } from '../html_5';

export interface IStretchWithTGBProps {
  context: IAdFoxBannerContext;
}

export function StretchWithTGB({ context }: IStretchWithTGBProps) {
  if (context.html) {
    return <HTML5Banner context={context} />;
  }

  return <TgbExtended context={context} />;
}
